/**
 * Fonema WhatsApp env — global `ENV` from Rails layouts (same pattern as Voice).
 */

/**
 * @returns {string}
 */
export function getFonemaWhatsappToken() {
  if (typeof ENV !== 'undefined' && ENV.FONEMA_WHATSAPP_TOKEN) {
    return ENV.FONEMA_WHATSAPP_TOKEN;
  }
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_FONEMA_WHATSAPP_TOKEN) {
    return process.env.REACT_APP_FONEMA_WHATSAPP_TOKEN;
  }
  return '';
}

/**
 * SDK token present (required to mount Fonema runtime).
 *
 * @returns {boolean}
 */
export function isFonemaWhatsappRuntimeConfigured() {
  return Boolean(getFonemaWhatsappToken());
}
